<app-loader></app-loader>
<div class="cancel-booking">
  <div class="find-outer">
    <h4>{{ title }}</h4>
    <div class="close-icon">
      <img src="assets/images/export-close.svg" alt="Close" (click)="closeDialog()" />
    </div>
  </div>

  <div class="parking-reservation">
    <p>{{ message }}</p>
  </div>

  <div class="cancel-outer1">
    <p-button class="mr-2" styleClass="p-button-confirm" label="Yes" (onClick)="confirm()"></p-button>
    <p-button label="No" styleClass="p-button-outlined" (onClick)="closeDialog()"></p-button>
  </div>
</div>